var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserIconEmo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M10.5 8.177a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0M14 2.343a5.833 5.833 0 1 0 0 11.667 5.833 5.833 0 0 0 0-11.667m-4.667 14A5.833 5.833 0 0 0 3.5 22.177v3.5h2.333v-3.5a3.5 3.5 0 0 1 3.5-3.5h9.334a3.5 3.5 0 0 1 3.5 3.5v3.5H24.5v-3.5a5.833 5.833 0 0 0-5.833-5.834z",
    clipRule: "evenodd"
  })));
};
export default SvgUserIconEmo;